import React from "react";
import "../../Style/HomeSecondBanner.css";
import Button from "react-bootstrap/Button";

const SecondBanner = () => {
  return (
    <>
      <div className="second_banner d-flex justify-content-center align-items-center flex-column">
      <div className="container-xxl p-0">
        <h3 className="d-flex justify-content-center align-items-center">DI HENNEBERRY</h3>
        <p className=" text-center" style={{ fontSize: "13px" }}>
          If you are exploring, purchasing, selling, or investing in available Sydney real estate, Di Henneberry offers a sophisticated level of service in the real estate industry based on a premise of reliability, insight, and personal service.
          Di takes the time to learn her client’s needs and preferences in order to optimize her search. Knowing the suburb’s potential and market value, Di will offer guidance and lead the negotiation process.
          Di utilizes her knowledge of the market, the property, and how to effectively capture the essence of the property to plan an individualised campaign to ensure the greatest marketing outcome.

        </p>
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-4">
          <Button className="workbtn">Work With Di Henneberry</Button>
          <Button className="searchbtn">Home Search</Button>
        </div>
        </div>
      </div>
    </>
  );
};

export default SecondBanner;
